import {
  downloadIframeClickMessage,
  downloadMessage
} from '../../express/common/sidebar/components/bottomMenu/downloadIndicator/helper';

export default class DownloadMessaging {
  constructor() {
    this.popupAdded = false;
  }

  downloadStarts(event, customText) {
    window.sendDownloadData(event, null, customText);
  }

  monitor(callback) {
    window.addEventListener("message", (ev) => {
      if (!ev.data) {
        return;
      }
      if (typeof (ev.data) != 'object') {
        return;
      }
      if (ev.data.kind !== downloadMessage) {
        return;
      }
      callback(ev.data);
    });
  }

  monitorIframeClick(callback) {
    window.addEventListener("message", (ev) => {
      if (!ev.data) {
        return;
      }
      if (typeof (ev.data) != 'object') {
        return;
      }
      if (ev.data.kind !== downloadIframeClickMessage) {
        return;
      }
      callback(ev.data);
    });
  }
}
